// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-theme-homestead -> apartment-management-consultants-theme-homestead-milburn -> longbow-luxury-apartments
// Generated: 2026-08-26T18:08:02.065Z
// Counts: 7 design, 37 content, 22 slot group, 0 collection binding, 7 section, 0 style

export const designOverrides = {
  "design._site.color.accent": {
    "cssVariable": "--vibe-color-accent",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_color_3"
  },
  "design._site.color.surface": {
    "cssVariable": "--vibe-color-surface",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_secondary_color"
  },
  "design._site.color.textMuted": {
    "cssVariable": "--vibe-color-text-muted",
    "overrideType": "VALUE",
    "value": "#303030",
    "mappedField": null
  },
  "design._site.font.accent": {
    "cssVariable": "--vibe-font-accent",
    "overrideType": "VALUE",
    "value": "'DM Sans', sans-serif",
    "mappedField": null
  },
  "design._site.font.body": {
    "cssVariable": "--vibe-font-body",
    "overrideType": "VALUE",
    "value": "'DM Sans', sans-serif",
    "mappedField": null
  },
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'DM Sans', sans-serif",
    "mappedField": null
  },
  "design._site.font.mono": {
    "cssVariable": "--vibe-font-mono",
    "overrideType": "VALUE",
    "value": "'DM Sans', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Longbow Luxury Apartments in Mesa, AZ, experience a lifestyle where natural beauty meets everyday convenience. Enjoy easy access to the scenic trails and outdoor recreation of Red Mountain Park and Usery Mountain Regional Park, ideal for hiking, biking, and taking in Arizona’s breathtaking desert landscape. Situated along holes #14 and #17 of the prestigious Longbow Golf Club, the community offers a premier golf course setting with serene fairway views and a peaceful atmosphere. Whether you're unwinding in nearby parks, teeing off just steps from home, or exploring local dining, shopping, and essential services, Longbow Luxury Apartments provides the perfect balance of relaxation, recreation, and accessibility. Experience <a href=\"https://www.liveatlongbow.com/amenities/\">luxury living amenities</a> with nature and convenience at your fingertips!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>At Longbow Luxury Apartments in Mesa, AZ, indulge in modern living with <a href=\"https://www.liveatlongbow.com/floor-plans/\">spacious one, two, and three-bedroom floor plans.</a> Our vibrant community features a heated resort-style pool, dog-friendly amenities, and engaging social events. Experience convenience and elegance with granite countertops, ample storage, and private patios. Your dream home awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Find Your Dream Life at Our Cozy Apartment Community</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "feeguide.aim_code": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_aim_property_code"
  },
  "floor-plans-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>1 - 3 Bedroom Apartments</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Find Your Perfect Home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Longbow Luxury Apartments in Mesa, AZ, where upscale living meets comfort and convenience. Enjoy <a href=\"https://www.liveatlongbow.com/floor-plans/\">expansive floor plans from one to three bedrooms,</a> complemented by resort-style amenities like a heated pool, pet-friendly spaces, and stunning golf course views. Elevate your lifestyle with modern features and vibrant community events!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience Lifestyle-Enhancing Features</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Longbow Luxury Apartments in Mesa, AZ, your dream home awaits! Choose from spacious one, two, or three-bedroom floor plans featuring gourmet kitchens, elegant touches, and private patios. Enjoy top-notch amenities like a heated resort-style pool, dog park, and vibrant community events. Secure your new lifestyle—lease online today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Apply Now</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Longbow Luxury Apartments in Mesa, AZ, you'll find a diverse range of thoughtfully designed floor plans, from cozy one-bedroom retreats to spacious three-bedroom havens. Our community blends modern comfort with a welcoming atmosphere. Have questions? Contact our leasing team today for more information on your future home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Reach Out to Learn More</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact Us</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Longbow Luxury Apartments in Mesa, AZ, we offer a variety of thoughtfully designed floor plans tailored to your lifestyle. Whether you seek the cozy charm of a one-bedroom or the spacious comfort of a three-bedroom, we have the perfect home waiting for you. Browse our available options today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Floor Plans</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Longbow Luxury Apartments in Mesa, AZ, experience a lifestyle where natural beauty meets everyday convenience. Enjoy easy access to the scenic trails and outdoor recreation of Red Mountain Park and Usery Mountain Regional Park, ideal for hiking, biking, and taking in Arizona’s breathtaking desert landscape. Situated along holes #14 and #17 of the prestigious Longbow Golf Club, the community offers a premier golf course setting with serene fairway views and a peaceful atmosphere. Whether you're unwinding in nearby parks, teeing off just steps from home, or exploring local dining, shopping, and essential services, Longbow Luxury Apartments provides the perfect balance of relaxation, recreation, and accessibility. Experience <a href=\"https://www.liveatlongbow.com/amenities/\">luxury living amenities</a> with nature and convenience at your fingertips!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Longbow Luxury Apartments in Mesa, AZ, where every detail combines elegance with comfort. Choose from spacious one, two, or three-bedroom layouts, each featuring gourmet kitchens and private balconies. Enjoy <a href=\"https://www.liveatlongbow.com/amenities/\">resort-style amenities</a> like a heated pool, scenic walking trails, and a dog park. Picture yourself living here!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Our Photo Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>1 - 3 Bedroom Apartments in Mesa , AZ</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Longbow Luxury Apartments</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Ideally Located in Mesa , AZ</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Neighborhood</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "parallaxbanner.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<p>Tour Anytime. From Any Distance.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "parallaxbanner.title": {
    "overrideType": "VALUE",
    "customValue": "<p>We're Here For You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Longbow Luxury, our pet-friendly apartments in Mesa, AZ welcome your cats and dogs! View our Pet Policy below for more information, and contact us today to schedule a personalized tour.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Living with Your Pet</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Pet Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>2 Pets Per Apartment Maximum</p><p>Dogs or Cats Welcome</p><p>$50/Monthly Pet Rent Per Pet</p><p>One-Time $500 Pet Fee Per Pet</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Living with Your Pet</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Longbow Luxury Apartments in Mesa, AZ, our thoughtfully designed floor plans cater to every lifestyle, from cozy one-bedroom nooks to spacious three-bedroom retreats. Schedule a tour today and uncover the vibrant community waiting for you. Curious about living here? Check out our residents' experiences!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.overline": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a Tour of Longbow Luxury Apartments</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule A Tour</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyoucontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank you for reaching out to Longbow Luxury Apartments in Mesa, AZ! Your interest in our thoughtfully designed one, two, and three-bedroom floor plans is truly appreciated. Expect to hear from our team soon to help you find your perfect home among our stylish, vibrant community.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Find Your Home"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans"
      }
    }
  },
  "floorplanslist.contact_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Explore The Area"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/neighborhood"
      }
    }
  },
  "floorplanslist.view_all_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/amenities"
      },
      "label": {
        "type": "VALUE",
        "customValue": "View Amenities"
      }
    }
  },
  "footer.managed_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_company_logo"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_company_logo_media.alt_text"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      },
      "label": {
        "type": "VALUE",
        "customValue": "Resident Login"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Schedule A Tour"
      }
    }
  },
  "herocallouts.cta1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Pricing & Availability"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/floor-plans/"
      }
    }
  },
  "petpolicy.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Explore All Amenities"
      }
    }
  },
  "herocallouts.cta2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Take a Tour"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour/"
      }
    }
  },
  "herocallouts.cta3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Explore Our Amenities"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/amenities/"
      }
    }
  },
  "herocallouts.cta4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Browse The Gallery"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/gallery/"
      }
    }
  },
  "imagecallouts.tile1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f778f-5eff-74dd-b1c5-d50b73e86c85.webp"
      }
    }
  },
  "imagecallouts.tile2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f778f-5e7c-7095-8eb7-180f47360a81.webp"
      }
    }
  },
  "imagecallouts.tile3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f778f-5e9d-76ee-812e-beb62d3a917e.webp"
      }
    }
  },
  "imagecallouts.tile4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f778f-5e9b-771d-9d5d-7827780e60e5.webp"
      }
    }
  },
  "parallaxbanner.primary_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Schedule a Visit"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "parallaxbanner.secondary_cta": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Take a Virtual Tour"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/virtual-tour"
      }
    }
  },
  "petpolicy.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f778f-6bf1-7749-ba4d-a79143b3be7f.webp"
      }
    }
  },
  "socialconnect.image1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f778f-6b47-73a2-a160-af995fae52a0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cozy bedroom with a queen-size bed, plush bedding, and a large window with city views."
      }
    }
  },
  "socialconnect.image2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f778f-6b8b-730b-ab0d-bd94a0bc744a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Billiard table and bar area in the apartment clubhouse lounge."
      }
    }
  },
  "socialconnect.image3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f778f-5eff-74dd-b1c5-d50b73e86c85.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Rooftop lounge area with bar, seating, and string lights overlooking city."
      }
    }
  },
  "socialconnect.image4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167469/019f778f-5e7c-7095-8eb7-180f47360a81.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern dining area with plush seating, large tables, and contemporary chandeliers."
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "anyonehome-chatbot",
      "blockId": "anyonehome-chatbot",
      "position": 0
    },
    {
      "sectionId": "lea-chatbot",
      "blockId": "lea-chatbot",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
